<rb-form-section [background]="false"
                 [title]="'APP.DOCUMENT.ASSIGN_DOCUMENT.DIALOG.ASSIGN_TO' | translate">
  <mat-form-field
    class="w-full">
    <input [formControl]="clientsSearch"
           matInput
           placeholder="{{ 'SEARCH_FIELD.PLACEHOLDER' | translate }}"
           type="text" />
    <mat-icon matIconSuffix svgIcon="search"></mat-icon>
  </mat-form-field>
  <mat-radio-group [formControl]="form.controls.clientId"
                   [style.height]="radioGroupHeight"
                   class="flex flex-col mb-[-1rem] overflow-scroll">
    <mat-radio-button *ngFor="let client of filteredClients$ | async" [value]="client.id" class="hover:bg-secondary">
      <rb-client-details [client]="client" class="block py-[0.5rem] w-[36rem]"></rb-client-details>
    </mat-radio-button>
  </mat-radio-group>
</rb-form-section>
